<template>
  <!-- READ ONLY MODE -->

  <div class="option-section pad-top20" v-if="mode == 'VIEW'">
    <div class="question-container pt-10">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div v-if="!question.verticalScale">
      <div v-if="activityDetails && activityDetails.newLayout == true">
        <ds-slider-custom-scale ref="slider" :value="getDefaultPositionValueForCustomScale(question)" :piecewise="true" width="1" direction="horizontal" class="horizontal-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="null" :labelActiveStyle="null" :dotSize="0"></ds-slider-custom-scale>
      </div>
      <div v-else>
        <ds-slider v-if="!question.verticalScale" ref="slider" :value="getDefaultPositionValueForCustomScale(question)" :piecewise="true" width="1" direction="horizontal" class="horizontal-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="null" :labelActiveStyle="null" :dotSize="0"></ds-slider>
      </div>
    </div>
    <ds-slider v-if="question.verticalScale" ref="slider" :value="getDefaultPositionValueForCustomScale(question)" :piecewise="true" width="2" direction="vertical" class="vertical-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="null" :labelActiveStyle="null" :dotSize="0"></ds-slider>
  </div>

  <!-- EDIT MODE -->
  <div v-else-if="mode == 'EDIT'">
    <!-- QUESTION -->

    <div class="p-0 pt-10 pb-10 clearfix">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-22" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
    <!-- ANSWER CHOICES -->

    <div class="row form-group">
      <div class="col-lg-1 pl-0 pt-5">Intervals</div>
      <div class="col-lg-1 p-0">
        <select name="intervals" v-model="question.intervals" v-on:change="changeLabelsLength(question.intervals)" class="form-control input-style" required>
          <option v-for="(option, index) in intervals" :key="index" v-bind:value="option.value">{{ option.name }}</option>
        </select>
      </div>
      <span class="col-lg-8 pt-5" v-if="question.reportable">
        Max of 8 intervals can be entered when dashboard graph option is selected.
      </span>
    </div>
    <span class="scale-info">Scale Labels</span>
    <span class="fa fa-info-circle info-circle pl-10 pt-10" aria-hidden="true" @click="toggleScaleValueInfo()" @blur="hideScaleValueInfo()" tabindex="-1"></span>
    <div class="info-circle-div interval-info-div" v-show="scaleValueInfoDiv" style="z-index: 90; width: 453px; height: auto; margin-left: 108px"><b>Horizontal scales:</b> minimum = displayed on left; maximum = displayed on right &#010; <b>Vertical scales:</b> minimum = displayed on bottom; maximum = displayed on top</div>
    <div v-if="question.intervals > 0">
      <div class="row form-group pb-10" v-for="(value, index) in question.formattedLabels" :key="index">
        <div v-if="index === 0">
          <div class="col-lg-1 mt-5 scale-right p-0">
            <span v-if="question.verticalScale">Top</span>
            <span v-if="!question.verticalScale">Right</span>
          </div>
          <div class="col-lg-9 p-0 scale-quill">
            <quill-editor class="bg-white mt-30" v-model="question.formattedLabels[question.formattedLabels.length - index - 1]" :options="editorOptionForLabels" v-on:blur="validateLabels(question.formattedLabels.length - index - 1)"></quill-editor>
            <span v-if="validLabels.includes(question.formattedLabels.length - index - 1)" class="error-style">Labels cannot exceed 35 characters in length</span>
          </div>
          <div class="col-lg-1 p-0 ml-13 score_cls">
            <h5 class="score_text">Score</h5>
            <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model.number="question.scores[question.formattedLabels.length - index - 1]"
              ><input v-model.number="question.scores[question.formattedLabels.length - index - 1]" value="999" oninput="javascript:this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" type="number" class="integer-plus-minus-input text-left ml-2" />
            </integer-plusminus>
          </div>
        </div>
        <div v-else-if="question.formattedLabels && index === question.formattedLabels.length - 1">
          <div class="col-lg-1 mt-5 scale-right p-0">
            <span v-if="question.verticalScale">Bottom</span>
            <span v-if="!question.verticalScale">Left</span>
          </div>
          <div class="col-lg-9 p-0 scale-quill">
            <quill-editor class="bg-white mt-30" :options="editorOptionForLabels" v-on:blur="validateLabels(question.formattedLabels.length - index - 1)" v-model="question.formattedLabels[question.formattedLabels.length - index - 1]"></quill-editor>
            <span v-if="validLabels.includes(question.formattedLabels.length - index - 1)" class="error-style">Labels cannot exceed 35 characters in length</span>
          </div>
          <div class="col-lg-1 p-0 ml-13 score_cls">
            <h5 class="score_text">Score</h5>
            <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model.number="question.scores[question.formattedLabels.length - index - 1]"
              ><input value="999" oninput="javascript: this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" v-model.number="question.scores[question.formattedLabels.length - index - 1]" type="number" class="integer-plus-minus-input text-left ml-2" />
            </integer-plusminus>
          </div>
        </div>
        <div v-if="question.formattedLabels && index !== 0 && index !== question.formattedLabels.length - 1">
          <div class="col-lg-1"></div>
          <div class="col-lg-9 p-0 scale-quill">
            <quill-editor class="bg-white mt-30" v-model="question.formattedLabels[question.formattedLabels.length - index - 1]" :options="editorOptionForLabels" v-on:blur="validateLabels(question.formattedLabels.length - index - 1)" v-if="!question.reportable"></quill-editor>
            <quill-editor class="bg-white mt-30" v-model="question.formattedLabels[question.formattedLabels.length - index - 1]" :options="editorOptionForLabels" v-on:blur="validateLabels(question.formattedLabels.length - index - 1)" v-if="question.reportable"></quill-editor>
            <span v-if="validLabels.includes(question.formattedLabels.length - index - 1)" class="error-style">Labels cannot exceed 35 characters in length</span>
          </div>
          <div class="col-lg-1 p-0 ml-13 score_cls">
            <h5 class="score_text">Score</h5>
            <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model.number="question.scores[question.formattedLabels.length - index - 1]"
              ><input value="999" oninput="javascript: this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" v-model.number="question.scores[question.formattedLabels.length - index - 1]" type="number" class="integer-plus-minus-input text-left ml-2" />
            </integer-plusminus>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import dsSlider from "@/lib/ds-slider-component";
import dsSliderCustomScale from "@/lib/ds-slider-component-custom-scale";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";
import _ from "lodash";

export default {
  name: "ActivityStepCustomScale",
  mixins: [activityStepCustomMessage],
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: 1
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    IntegerPlusminus,
    dsSlider,
    dsSliderCustomScale,
    quillEditor
  },
  data() {
    return {
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      intervals: [
        { name: " ", value: "0" },
        { name: "2", value: "2" },
        { name: "3", value: "3" },
        { name: "4", value: "4" },
        { name: "5", value: "5" },
        { name: "6", value: "6" },
        { name: "7", value: "7" },
        { name: "8", value: "8" },
        { name: "9", value: "9" },
        { name: "10", value: "10" },
        { name: "11", value: "11" },
        { name: "12", value: "12" },
        { name: "13", value: "13" }
      ],
      infoDiv: false,
      scaleInfoDiv: false,
      intervalInfoDiv: false,
      scoreInfoDiv: false,
      lengthInfoDiv: false,
      pointerInfoDiv: false,
      scaleValueInfoDiv: false,
      editorOptionForLabels: {
        placeholder: "Enter Value",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      validLabels: [],
      isAddHelpEnabled: false
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  },
  created() {
    this.$root.$on("Toggle_Preview", () => {
      if (!this.$refs) {
        return;
      }
      if (!this.$refs.slider) {
        return;
      }
      setTimeout(() => {
        [this.$refs.slider].forEach(element => {
          element.refresh();
        });
      }, 300);
    });
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    changeLabelsLength(intervals) {
      if (intervals == 0 || !intervals) {
        this.$toastr.error("Please specify # of intervals.");
        return;
      } else if (intervals < 1 || intervals > 14) {
        this.$toastr.error("Minimum and maximum value of interval should be 2 to 13");
        return;
      }
      this.question.formattedLabels.length = intervals;
      this.$forceUpdate();

      for (let i = 0; i < intervals; i++) {
        if (!this.question.id) {
          this.question.scores[i] = 0;
        } else {
          this.question.scores[i] = this.question.score[i] ? this.question.score[i] : 0;
        }
      }

      if (!this.question.formattedLabels) {
        this.question.formattedLabels = [];
      }
      this.question.formattedLabels.length = intervals;
      this.$forceUpdate();
    },
    hideIntervalInfo() {
      this.intervalInfoDiv = false;
      this.$el.blur();
    },
    showIntervalInfo() {
      this.intervalInfoDiv = true;
      this.$el.focus();
    },
    toggleIntervalInfo() {
      if (this.intervalInfoDiv) {
        this.hideIntervalInfo();
      } else {
        this.showIntervalInfo();
      }
    },
    getDefaultPositionValueForCustomScale(question) {
      const defaultPointerPosition = question.defaultPointerPosition;
      if (defaultPointerPosition == "none" || defaultPointerPosition == "left" || defaultPointerPosition == "bottom") {
        return question.formattedLabels[0];
      } else if (defaultPointerPosition == "right" || defaultPointerPosition == "top") {
        return question.formattedLabels[question.formattedLabels.length - 1];
      } else if (defaultPointerPosition == "middle") {
        const l = question.formattedLabels.length;
        if (l % 2 == 0) {
          const halfLength = l / 2;
          return question.formattedLabels[halfLength - 1];
        } else {
          return question.formattedLabels[(l - 1) / 2];
        }
      } else {
        return question.formattedLabels[0];
      }
    },
    toggleInfoDiv() {
      if (this.infoDiv) {
        this.hidePopup();
      } else {
        this.showPopup();
      }
    },
    hidePopup() {
      this.infoDiv = false;
      this.$el.blur();
    },
    showPopup() {
      this.infoDiv = true;
      this.$el.focus();
    },
    hideScaleValueInfo() {
      this.scaleValueInfoDiv = false;
      this.$el.blur();
    },
    toggleScaleValueInfo() {
      if (this.scaleValueInfoDiv) {
        this.hideScaleValueInfo();
      } else {
        this.showScaleValueInfo();
      }
    },
    showScaleValueInfo() {
      this.scaleValueInfoDiv = true;
      this.$el.focus();
    },
    validateLabels(index) {
      const lastLabelIndex = this.question.formattedLabels.length - 1;
      const label = this.stripHtml(this.question.formattedLabels[index]);
      if (label && label.length > 35 && index != 0 && index != lastLabelIndex) {
        this.validLabels.push(index);
      } else {
        this.validLabels.forEach((item, vindex) => {
          if (item === index) {
            this.validLabels.splice(vindex, 1);
          }
        });
      }
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      let scaleLabels = [];

      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      if (question.intervals == 0 || question.intervals == null || (question.intervals && question.intervals.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Please specify # of intervals.";
        return errorObj;
      }
      if (question.verticalScale) {
        let interval = Number(question.intervals);
        if (!question.formattedLabels[interval - 1]) {
          errorObj.isValid = false;
          errorObj.msg = "Top value is required.";
          return errorObj;
        }
        if (!question.formattedLabels[0]) {
          errorObj.isValid = false;
          errorObj.msg = "Bottom value is required.";
          return errorObj;
        }
      } else {
        let interval = Number(question.intervals);
        if (!question.formattedLabels[0]) {
          errorObj.isValid = false;
          errorObj.msg = "Left value is required.";
          return errorObj;
        }
        if (!question.formattedLabels[interval - 1]) {
          errorObj.isValid = false;
          errorObj.msg = "Right value is required.";
          return errorObj;
        }
      }
      for (let i = 0; i < question.formattedLabels.length; i++) {
        const label = question.formattedLabels[i];
        if (!label) {
          errorObj.isValid = false;
          errorObj.msg = "Value is required.";
          return errorObj;
        }
      }
      if (_.uniq(question.formattedLabels).length !== question.formattedLabels.length) {
        errorObj.isValid = false;
        errorObj.msg = "Please enter unique interval values.";
        return errorObj;
      }
      if (question.formattedLabels && question.formattedLabels.length > 0) {
        let valid = true;
        const lastLabelIndex = question.formattedLabels.length - 1;
        question.formattedLabels.forEach((label, index) => {
          const l = this.stripHtml(label);
          if (l.length > 35 && (index != 0) & (index != lastLabelIndex)) {
            errorObj.msg = "Label max chars = 35.";
            errorObj.isValid = false;
            valid = false;
          }
        });
        if (valid) {
          this.validLabels = [];
        } else {
          return errorObj;
        }
      }
      question.intervals = Number(question.intervals);
      scaleLabels = _.without(question.formattedLabels, "", null, undefined);
      const customScaleValidity = question.formattedBody && question.sequence && question.intervals > 1 && question.intervals <= 13 && scaleLabels.length > 0 && scaleLabels.length === Number(question.intervals) && this.validLabels.length === 0 && _.uniq(question.formattedLabels).length === question.formattedLabels.length;
      return { isValid: customScaleValidity };
    }
  }
};
</script>

<style scoped lang="scss">
.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -16px;
}
.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
  .col-sm-3 {
    float: left;
  }
}

.scaleLabels {
  font-size: 12px;
  color: #666669;
}

.vertical-vue-slider {
  height: 300px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
  text-align: center;
}

h5.question {
  top: 49px !important;
  position: relative;
}
</style>
